const Cache = {
  retrieve (key) {
    const storageData = localStorage.getItem(key)
    if (!storageData) {
      return false
    }
    let data
    try {
      data = JSON.parse(storageData)
    } catch (err) {
      return false
    }
    if (!data) {
      return false
    }
    const now = Date.now()

    if (!data.timestamp) {
      return false
    }
    if (!data.expiration) {
      return false
    }
    if (now > data.timestamp + data.expiration) {
      return this.delete(key)
    }
    return data.value
  },
  /**
   *
   * @param key
   * @param data
   * @param expiration count of hours
   */
  add (key, data, expiration = 1) {
    const params = {
      timestamp: Date.now(),
      expiration: expiration * 3600 * 1000,
      value: data
    }
    return localStorage.setItem(key, JSON.stringify(params))
  },
  delete (key) {
    localStorage.removeItem(key)
  }
}

module.exports = Cache
